import { Outlet } from 'react-router-dom-v5-compat';

import { useVerifyAuthentication } from 'utils/customHooks/useVerifyAuthentication';

/**
 * @component
 * @description A wrapper component for authenticated routes to check login
 */
export const OpAuthenticatedRoute = ({
  /**
   * This will be removed in a follow-up
   * @see {@link https://jira.mot-solutions.com/browse/NEX-890}
   */
  isRedirectUrlEnabled = true,
}: {
  isRedirectUrlEnabled?: boolean;
}) => {
  // Check if logged in, if not redirect the user to login
  const { isLoading } = useVerifyAuthentication({ isRedirectUrlEnabled });

  return isLoading ? null : <Outlet />;
};
